import { render, staticRenderFns } from "./renew.vue?vue&type=template&id=aac13a8a"
import script from "./renew.vue?vue&type=script&lang=js"
export * from "./renew.vue?vue&type=script&lang=js"
import style0 from "./renew.vue?vue&type=style&index=0&id=aac13a8a&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {S2FeedbackToast: require('/usr/src/app/node_modules/front-components/components/ui/notification/FeedbackToast.vue').default})
